import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './panel.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

/**
 * Render a {@link Panel} content component.
 *
 * @param {Object} [props] - The current component properties
 * @param {ReactElement} [props.children] - The children to be rendered
 * @param {string} [props.className] - Classname to be added
 * @param {Object} [props.style] - Addional style attribute contents
 * @returns {ReactElement}
 */
function PanelContent(props) {
    const { children, className, style } = props

    const classNameWrapper = cx(styles['panel-content'], className, 't3sel-panel-content')

    return (
        <div className={classNameWrapper} style={style}>
            {children}
        </div>
    )
}

PanelContent.propTypes = propTypes

export default PanelContent
